export default function decimal (number) {
    number = number*1;
    return number.toFixed(2);
}